import { Pipe, PipeTransform, Inject, LOCALE_ID, Injector } from '@angular/core';
import { DatePipe } from '@angular/common';


@Pipe({
    name: "dateformatter"
})
export class DateFormatterPipe implements PipeTransform {

    constructor(private defaultDatePipe: DatePipe, private injector: Injector) {
        // console.log("dateformatter pipe");
        // console.log("LOCALE_ID:" + this.injector.get(LOCALE_ID));
    }


    public transform(value: string, format: string | null): string {
        // console.log(value);
        // console.log(format);
        // console.log("MT:" + this.defaultDatePipe.transform(value, format));
        // https://stackoverflow.com/questions/41820714/angular-2-dynamicly-get-locale-id-resolve-per-request
        // The problem is that LOCALE_ID provider registered as singleton and i always get first resolved value...
        let culture: string = this.injector.get(LOCALE_ID);
        if (culture.toLowerCase() == "en-us") {
            console.log("Locale_Id:" + culture);
            return this.defaultDatePipe.transform(value, "fullDate");
        } else {
            return this.defaultDatePipe.transform(value, format);
        }
    }


}


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/common/pipe/date-formatter.pipe.ts